import JackpotSlotTemplate from "./jackpot-slot-template";

export default JackpotSlotTemplate;
